export const areValidValues = (...values) => values.every((value) => value !== undefined && value !== null && value !== '');
export const isValidValue = (value) => value !== undefined && value !== null && value !== '';
export const normalizeBooleanParam = (value) => value === true || value === 'true';
